export default __webpack_public_path__ + "static/media/gajapathi.d470ab5d.jpeg";